import React, {Component} from 'react'
import {connect} from 'react-redux'
import UserListing from '../components/UserListing'
import {UserActions} from '../reducers/user/index'
import AdminProfile from '../pages/AdminProfile'
import {
  Row,
  Col,
  Grid,
  Panel,
  PanelBody,
  PanelContainer,
  Pagination
} from '@sketchpixy/rubix'
import {ADMIN_ROLE} from '../utils'

class User extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedRoleType: ADMIN_ROLE
    }
  }

  activeUserInfo = (user) => {
    const {history: {location: {pathname}}, history} = this.props
    const {id} = user;
    history.push({...history, pathname: `/admin/profile/${id}`, editable: true, search:"?backTo="+pathname})
    // return <AdminProfile profile entityId={id} />
  }

  loadMoreUsers = (pageNumber) => {
    const {searchText = undefined, filters = undefined} = this.props
    const {selectedRoleType} = this.state

    this.props.getAllUsersInfo(selectedRoleType, pageNumber, searchText, filters)
    this.setState({
      user: {}
    })
  }

  backToUserList = () => {
    this.setState({
      user: {}
    })
  }

  render() {
    let {user = {}} = this.state
    const {
      pageNumber = 1, pageSize, allUsersCount = 0,
      fetching = true, error = undefined, role = null, history
    } = this.props

    return (
      <PanelContainer className='inbox' collapseBottom>
        <Panel>
          <PanelBody
            style={{paddingTop: 0}}>
            <UserListing history={history} getSpecificUser={this.activeUserInfo}
              
              role={role} />
            {
              pageNumber && allUsersCount > 10 ? <Grid>
                <Row>
                  <Col xs={12} style={{paddingTop: 12.5}}>
                    <h3 className='text-center'>
                      <Pagination
                        prev
                        next
                        first
                        last
                        ellipsis
                        boundaryLinks
                        bsSize='small'
                        maxButtons={4}
                        items={Math.ceil(allUsersCount / pageSize)}
                        activePage={parseInt(pageNumber)}
                        onSelect={this.loadMoreUsers} />
                    </h3>
                  </Col>
                </Row>
              </Grid>
                : null
            }
          </PanelBody>
        </Panel>
      </PanelContainer>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  getAllUsersInfo: (selectedRoleType, pageNumber, searchText, filters) => {
    dispatch(UserActions.getAllUserInfoRequest(selectedRoleType, pageNumber, searchText, filters))
  }
})

const mapStateToProps =
  ({
     user: {
       all: {
         pageNumber = 1, pageSize = 10, allUsersCount = 0,
         fetching = false, error = undefined,
         searchText = undefined, schoolFilter = undefined,
         approvalStatus = undefined
       }
     },
     login: {
       role
     }
   }) => ({
     pageNumber, pageSize, allUsersCount, fetching, error, role, searchText, schoolFilter, approvalStatus
   })

export default connect(mapStateToProps, mapDispatchToProps)(User)
